import { useEffect, useState } from "react";

import { useGetApi, usePostApi } from "../../../../hooks";

const useGetAllYachts = (clientid?: string) => {
  const [yachts, setYachts] = useState([]);
  const [yachtsLoading, setYachtsLoading] = useState(false);

  const { post } = usePostApi();

  const { data } = useGetApi({
    request: "get-management",
    body: {
      _sect: "_clients",
      _client: "6dfb8433-6130-ef36-356a-6f205a2528fc",
    },
  });

  const fecthAllYachts = async () => {
    if (data) {
      try {
        setYachtsLoading(true);
        const clientsYachts = await Promise.all(
          data.data.content.list.map(async (client: any) => {
            const vesselsData = await post({
              request: "get-management",
              body: { _sect: "_clients", _org: client.orgid },
            });
            return vesselsData.data.content.list;
          }),
        );
        setYachts(clientsYachts.flatMap((yachts: any) => yachts));
      } catch (e) {
        console.log(e);
      } finally {
        setYachtsLoading(false);
      }
    }
  };

  useEffect(() => {
    void fecthAllYachts();
  }, [data]);

  return { isLoading: yachtsLoading, yachts };
};
export default useGetAllYachts;
